import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { WebTransaction } from "../../../models";
import { Subscription } from "rxjs";
import { CustomerService } from "../../../services";
import { TransactionDetailService } from "../../../services/transaction-detail.service";
import { filter } from "rxjs/operators";

@Component({
    selector: "app-transaction-dialog-card",
    templateUrl: "./transaction-dialog-card.component.html",
    styleUrls: ["./transaction-dialog-card.component.scss"],
})
export class TransactionDialogCardComponent implements OnInit, OnDestroy
{

    @Input() transaction: WebTransaction;
    @Input() elementId: string = "myTableElementId";

    branchCustId: string;

    transactionDetailList: WebTransaction[];
    transactionSubscription: Subscription;

    customerSubscription: Subscription;

    isPayment: boolean;

    constructor(
        private transactionsDetailService: TransactionDetailService,
        private customerService: CustomerService,
    ) { }

    ngOnInit(): void 
    {
        this.transactionSubscription = this.transactionsDetailService.recentTransactions.subscribe(d =>
        {
            this.transactionDetailList = d;
        });

        this.customerSubscription = this.customerService.customer
            .pipe(filter(customer => !!customer))
            .subscribe(customer =>
            {
                this.branchCustId = customer.BranchCustId;
            });

        this.getData(this.transaction);
    }

    getData(trans: WebTransaction)
    {
        if (trans.IsPayment) 
        {
            this.isPayment = true;
            this.transactionsDetailService.getCustomerHistoryPaymentDetail(this.branchCustId, trans.CheckNo, trans.Date, trans.Tran);
        }
        else 
        {
            this.isPayment = false;
            this.transactionsDetailService.getCustomerHistoryDetail(this.branchCustId, trans.RefNo, trans.Date, trans.Tran);
        }
    }

    ngOnDestroy()
    {
        this.transactionSubscription.unsubscribe();
        this.customerSubscription.unsubscribe();
    }
}
